module.exports = __webpack_public_path__ + "reward-icon.svg";